module.exports = __webpack_public_path__ + "img/logo_vi.846cf573.svg";